<template lang="pug">
  router-link#extra-button(v-if="extraButton.linkEntry" :to="extraButton.linkEntry" :class="buttonColor")
    span.show(v-html="extraButton.label")
  a#extra-button(v-else-if="extraButton.linkUrl" :href="extraButton.linkUrl" target="_blank" rel="noreferrer" :class="buttonColor")
    span.show(v-html="extraButton.label")
</template>

<script>
import debug from 'debug'
let log = debug('component:ExtraButton')

export default {
  name: 'extraButton',
  props: {
    extraButton: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      buttonColor: this.$route.meta.menuColor,
      buttonTextColor: '',
    }
  },
  watch: {
    $route (to, from) {
      this.buttonColor = this.$route.meta.menuColor
    },
    open () {
      return this.open
    },
  },
  mounted () {
    log('Mounted')

    if (window.innerWidth >= 768) {
      if (this.buttonColor === 'dark') {
        this.buttonBgColor = '#2a2423'
        this.buttonTextColor = '#f6eeeb'
      } else {
        this.buttonBgColor = '#f6eeeb'
        this.buttonTextColor = '#2a2423'
      }
    }
  },
}
</script>

<style scoped lang="scss">
#extra-button {
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  color: $black;
  background: $cream;
  position: fixed;
  right: 8px;
  bottom: 35px;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  width: 100px;
  height: 100px;
  border: $cream;
  border-radius: 50%;
  transition: all 0.3s ease;
  margin-top: 5px;
  font-family: 'Martha Black';
  font-size: 18px;
  z-index: 1;

  &.dark {
    background-color: #2a2423;
    color: #f6eeeb;
  }

  @media #{$mobile} {
    width: 68px;
    height: 64px;
    font-size: 13px;
    position: fixed;
    right: 8px;
    bottom: 8px;
    padding: 0;
    color: $violent-sunset;
  }

  span {
    display: block;
    opacity: 0;

    &.show {
      opacity: 1;
      transition: opacity 0.5s ease 0.9s;
    }

    @media #{$mobile} {
      margin: 0px;
    }
  }

  &:hover {
    cursor: pointer;
    text-decoration: none;
    background: $violent-sunset;
    @media #{$mobile} {
      background: transparent;
    }
  }

  &.open {
    &.booking {
      background: red;
      // animation: animateButtonMenuOpen 1s ease forwards;
    }
  }

  &.animate-button {
    animation: animateButton 1.8s ease;

    @media #{$mobile} {
      animation: animateMobileButton 1.8s ease;
    }
  }

  &.close-button {
    animation: closeButton 1s ease;

    @media #{$mobile} {
      animation: closeMobileButton 1s ease;
    }
  }
}

/***************** Button animtaion - Menu Closed ***********************/

@keyframes animateButton {
  0% {
    background: $violent-sunset;
  }

  90% {
    transform: scale(70);
    background: $violent-sunset;
  }

  100% {
    background: $cream;
  }
}

@keyframes closeButton {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(70);
  }

  90% {
    background: $violent-sunset;
  }

  99% {
    transform: scale(1);
  }
}

/***************** Button animtaion - Menu Open ***********************/

@keyframes animateButtonMenuOpen {
  0% {
    position: fixed;
    right: 3vw;
    color: $black;
    background: $violent-sunset;
  }
  5% {
  }

  90% {
    color: $black;
    transform: scale(70);
  }

  100% {
    color: $violent-sunset;
    background: $violent-sunset;
  }
}

/***************** Button animtaion - Mobile ***********************/

@keyframes closeMobileButton {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(70);
  }

  90% {
    background: $cream;
    color: $cream;
  }

  100% {
    transform: scale(1);
    color: $violent-sunset;
  }
}

@keyframes animateMobileButton {
  0% {
    background: $violent-sunset;
    color: $violent-sunset;
  }

  90% {
    background: $violent-sunset;
    color: $violent-sunset;
    transform: scale(30);
  }

  100% {
    background: transparent;
  }
}

</style>
